import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
const poison_cloud = {
  slug: "poison_cloud",
  name: "Poison Cloud",
  description: "Creates a toxic mist that poisons all who enter.",
  abilityIcon: "poison_cloud",
  costs: [
    { stat: "mana", value: 30 }
  ],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: ["poison"]
        }
      }
    ],
    [24]: [
      {
        hexes: HEX.CIRCLE_2,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: ["poison"]
        }
      }
    ],
    [48]: [
      {
        hexes: HEX.CIRCLE_2,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: ["poison"]
        }
      }
    ],
    [72]: [
      {
        hexes: HEX.CIRCLE_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: ["poison"]
        }
      }
    ],
    [96]: [
      {
        hexes: HEX.CIRCLE_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: ["poison"]
        }
      }
    ]
  },
  tags: ["spell", "ranged", "aoe", "red"],
  effectTemplate: `Impact: {0}
Ring 1: {1}
Ring 2: {2}`
};
export {
  poison_cloud
};
//# sourceMappingURL=data:application/json;base64,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
